"use client";

import Link from "next/link";
import { useI18n } from "@/lib/i18n/hook";

export function Footer() {
  const { t } = useI18n();

  return (
    <footer className="border-t bg-background">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 px-4 md:px-6 lg:px-8 py-8">
        <div className="flex items-center gap-2">
          <Link href="/" className="flex items-center">
            <svg
              width="64"
              height="64"
              viewBox="0 0 200 200"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-6 w-6"
            >
              <path d="M 100 150 m -90,0 a 90,90 0 1,1 180,0 a 70,70 0 1,0 -140,0 a 50,50 0 1,1 100,0" />
            </svg>
            <span className="font-bold text-lg ml-2">{t("appTitle")}</span>
          </Link>
        </div>
        <nav className="flex flex-wrap justify-center gap-6">
          <Link
            href="/company"
            className="text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            {t("company.title")}
          </Link>
          <Link
            href="/terms"
            className="text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            {t("terms.title")}
          </Link>
          <Link
            href="/privacy"
            className="text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            {t("terms.privacyPolicy")}
          </Link>
        </nav>
      </div>
      <div className="mt-8 text-center text-sm text-muted-foreground">
        © {new Date().getFullYear()} OKMoney. All rights reserved.
      </div>
    </footer>
  );
}
